import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBlock: 40,
    // paddingInline: theme.palette.custom.lgPaddingInline,
    paddingInline: 12,
    background: '#fde5e5',
    // marginBlock: 40,
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
  },
  wrapper: {
    display: 'flex',
    // justifyContent: 'center',
    flexWrap: 'wrap',
    rowGap: 16,
  },
  processWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    paddingInline: 8,
    // [theme.breakpoints.down('md')]: {
    //   justifyContent: 'flex-s',
    // },
  },
  img: {
    width: 48,
    height: 48,
    [theme.breakpoints.down('lg')]: {
      width: 44,
      height: 44,
    },
  },
  title: {
    '& .MuiTypography-root': {
      fontWeight: 600,
      paddingBlockEnd: 4,
    },
  },
  content: {
    '& .MuiTypography-root': {
      color: '#00000080',
    },
  },
}))

export default useStyles
